import { LazyIssueApp } from '@jira/issue__lazy-app/src/LazyIssueApp.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdContent } from '@jira/navigation-apps__constants/src/SidebarIdContent.tsx';
// eslint-disable-next-line jira/import/no-restricted-import, camelcase
import { DEPRECATED_DO_NOT_USE_projectDetailsResource } from '@jira/router-resources__business-project-details/src/BusinessProjectDetailsUseProjectDEPRECATEDDONOTUSE.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { fieldsResource } from '@jira/router-resources__business-fields/src/fieldsResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { ListSkeleton } from '@jira/platform__skeletons/src/ui/list/ListSkeleton.tsx';
import {
	composeLayouts,
	createLayout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { classicSoftwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { embeddedIssuePreloadLayoutBuilder } from '@jira/platform__layouts-issue-preload-layout/src/index.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { softwareListClassicRoute } from '@jira/router-routes__classic-projects-routes/src/softwareListClassicRoute.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';

import { projectCreatePermissionsResource } from '@jira/router-resources__project-permissions/src/projectCreatePermissionsResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { projectThemeResource } from '@jira/router-resources__project-theme/src/projectThemeResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { expVal } from '@atlassian/jira-feature-experiments';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { getRouteReporting } from '@jira/router-routes__issue-navigator-entries/src/common/getRouteReporting.tsx';
import { ProjectIssueNavigatorSkeleton } from '@jira/platform__skeletons/src/ui/issue-navigator/components/project-app.tsx';
import {
	GSNIssueNavigatorPageEntryPointWithNested,
	issueNavigatorPageEntryPointWithNested,
} from '@jira/router-routes__issue-navigator-entries/src/ui/index.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { getCommonProjectResources } from '@jira/router-routes__issue-navigator-entries/src/common/getCommonProjectResources.tsx';
import { getSsrCircuitBreaker } from '@jira/router-routes__issue-navigator-entries/src/common/getSsrCircuitBreaker.tsx';
import { adjustSsrFetchTimeout } from '@jira/router-routes__issue-navigator-entries/src/common/getSsrFetchTimeout.tsx';
import { GSNSoftwareListRouteEntry, softwareListRouteEntry } from './ui/software/list/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareListClassicRouteEntry: Route = createEntry(softwareListClassicRoute, () => ({
	group: 'classic-software',
	meta: fg('jira_list_nin_merge')
		? {
				capability: NIN_NEW_ISSUE_NAVIGATOR,
				reporting: getRouteReporting(),
			}
		: undefined,
	skeleton: fg('jira_list_nin_merge') ? ProjectIssueNavigatorSkeleton : ListSkeleton,
	entryPoint() {
		if (fg('jira_list_nin_merge')) {
			return fg('navx-global-side-nav')
				? GSNIssueNavigatorPageEntryPointWithNested
				: issueNavigatorPageEntryPointWithNested;
		}
		if (fg('navx-global-side-nav')) {
			return GSNSoftwareListRouteEntry;
		}
		return softwareListRouteEntry;
	},
	layout: fg('jira_list_nin_merge')
		? createLayout(genericProjectLayout)
		: composeLayouts(
				classicSoftwareProjectLayout,
				embeddedIssuePreloadLayoutBuilder([{ query: ['selectedIssue'] }]),
			),
	bifrost: {
		bifrostGroup: 'issue-navigator',
		manifestName: 'jira-spa-issue-navigator.json',
		// Experiment to test the impact of increasing the resource timeout for issue navigator routes with more performance SSR
		fetchTimeout: adjustSsrFetchTimeout(expVal('nin_ssr_resource_timeout', 'timeout', 0)),
		circuitBreakerConfig: fg('jira_list_nin_merge') ? getSsrCircuitBreaker() : undefined,
	},
	navigation: fg('jira_list_nin_merge')
		? {
				menuId: MenuIdProjects,
				horizontal: AsyncHorizontalNavJira,
				sidebarId: SidebarIdContent,
			}
		: {
				menuId: MenuIdProjects,
				horizontal: AsyncHorizontalNavJira,
				sidebarId: SidebarIdContent,
			},
	// TODO: This is a copy of getProjectViewResources, but it has been copied in order to replace
	//  with .
	resources: fg('jira_list_nin_merge')
		? [...getCommonProjectResources({ isUsingSidebarEntrypoint: true }), ...getIssueViewResources()]
		: [
				// the below 5 resources are copied from getBusinessProjectResources
				// they should be feature flagged and removed when it is safe to do so or
				// moved out of business packages
				// start getBusinessProjectResources
				projectCreatePermissionsResource,
				// eslint-disable-next-line camelcase
				DEPRECATED_DO_NOT_USE_projectDetailsResource,
				// end getBusinessProjectResources
				...getNavigationResources({
					isUsingSidebarEntrypoint: true,
				}),
				...getIssueViewResources(),
				// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
				// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
				incidentExperimentTraitResource,
				// eslint-disable-next-line jira/router/no-project-context-resource
				projectContextResource,
				forgeProjectModuleResource,
				staticProjectSidebarNavigationResource,
				staticProjectSidebarConnectAddonsNavigationResource,
				// end of resources expanded from getNavigationSidebarProjectResource
				fieldsResource,
				projectThemeResource,
			],
	afterPaint: fg('jira_list_nin_merge') ? undefined : [LazyIssueApp],
	ufoName: fg('jira_list_nin_merge') ? 'classic-list-nin' : 'classic-list',
	supportsPreviewPanel: true,
	supportsProjectTheme: expVal('jira-list-full-theming-exp', 'isEnabled', false)
		? 'full'
		: 'contoured',
	isHydrateRootEnabled: fg('jira_list_nin_merge'),
	isStreamingEnabled: fg('jfp-magma-ssr-streaming-enable-nin'),
	excludeFromWrmDeferredLoading: fg('jira_list_nin_merge'),
}));
